import { useGameStore } from "../../app/gameStore";
import { PALETTE } from "../palette";

/**
 * Warm workshop lighting rig per M1a: cream-amber key with soft shadow,
 * sage-over-cream hemisphere fill, low rim from behind. No real volumetrics —
 * that illusion comes from bloom (PostStack) plus DustMotes.
 *
 * The key light aims at the board's centre and its shadow camera is sized to
 * cover the board. Both used to be constants, which showed as a pale band
 * across the far corner of the wider stages: that was the edge of the shadow
 * map, where the board simply ran out of shadow to receive.
 */
export function LightingRig() {
  const cols = useGameStore((s) => s.snapshot.cols);
  const rows = useGameStore((s) => s.snapshot.rows);

  const centreX = (cols - 1) / 2;
  const centreZ = (rows - 1) / 2;
  // Half-extent plus headroom for tall hardware and the table lip.
  const extent = Math.max(cols, rows) * 0.75 + 3;

  return (
    <>
      <directionalLight
        color={PALETTE.keyLight}
        intensity={2.2}
        position={[centreX + 2.5, 9, centreZ + 1.5]}
        target-position={[centreX, 0, centreZ]}
        castShadow
        shadow-mapSize={[2048, 2048]}
        shadow-camera-left={-extent}
        shadow-camera-right={extent}
        shadow-camera-top={extent}
        shadow-camera-bottom={-extent}
        shadow-radius={4}
      />
      <hemisphereLight color={PALETTE.cream} groundColor={PALETTE.sage} intensity={0.6} />
      <directionalLight color={PALETTE.rimLight} intensity={0.35} position={[-5, 4, -6]} />
      <ambientLight color={PALETTE.cream} intensity={0.15} />
    </>
  );
}
